import { defineMessages } from 'react-intl';

const errorMessages = defineMessages({
  generalError: {
    id: 'site_pdp.add_to_cart_error',
    defaultMessage: 'There was an error adding the item to your cart.',
  },
  sizeSelectorError: {
    id: 'site_pdp.select_size_error',
    defaultMessage: 'Please select item size.',
  },
  soldOutError: {
    id: 'site_pdp.sold_out_error',
    defaultMessage:
      'This product is out of stock and cannot be added to your cart.',
  },
  blacklistedWordError: {
    id: 'site_pdp.embroidery_blacklisted_word',
    defaultMessage:
      'The embroidered text contains a blocked word. Please try again.',
  },
  mysteryBoxLimitError: {
    id: 'site_pdp.mystery_box_limit_error',
    defaultMessage: 'Whoops! You already have a mystery box in your cart.',
  },
});

export default errorMessages;
